var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-action"},[_c('action-title'),_c('div',{staticClass:"action-button"},[_c('btn',{attrs:{"variant":"primary-new","size":"big"},on:{"click":_vm.authorize}},[_vm._v(_vm._s(_vm.$t('landing.startUsing')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }